export default __webpack_public_path__ + "static/media/patterns-no-7.af19f6a7.ogg";